import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Check authentication status
    const checkAuthentication = () => {
      const adminLoggedIn = localStorage.getItem('adminLoggedIn') === 'true';
      const adminRole = localStorage.getItem('adminRole');
      
      // Verify both adminLoggedIn flag and Admin role
      const authenticated = adminLoggedIn && adminRole === 'Admin';
      
      // Set authentication state
      setIsAuthenticated(authenticated);
      
      // Only clear localStorage if we're definitely not authenticated AND there's partial/invalid data
      // This prevents clearing valid authentication on every check
      if (!authenticated && (adminLoggedIn || adminRole)) {
        // Only clear if there was partial/invalid data (stale state)
        // This means either adminLoggedIn was true but role was wrong, or vice versa
        localStorage.removeItem('adminLoggedIn');
        localStorage.removeItem('adminRole');
        localStorage.removeItem('adminUsername');
      }
    };

    // Check on mount
    checkAuthentication();

    // Listen for storage changes (e.g., logout from another tab)
    // Only react to storage events from other tabs/windows, not same tab
    const handleStorageChange = (e) => {
      // Only handle storage events from other tabs
      if (e.storageArea === localStorage && (e.key === 'adminLoggedIn' || e.key === 'adminRole')) {
        checkAuthentication();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []); // Only check on mount, not on every route change

  // Show loading while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mb-4"></div>
          <p className="text-gray-600">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace state={{ from: location.pathname }} />;
  }

  // Render children if authenticated
  return children;
};

export default ProtectedRoute; 